import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from '@environments/environment';
import { Observable, from, throwError } from 'rxjs';
import { catchError, switchMap } from 'rxjs/operators';
import { PayloadEncryptionService } from '../utils/payload-encryption/payload-encryption.service';

@Injectable()
export class PayloadEncryptionInterceptor implements HttpInterceptor {
  constructor(private enc: PayloadEncryptionService) {}

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    if (environment.payload_encrypt !== 'true') {
      return next.handle(req);
    }

    const method = req.method.toUpperCase();
    const shouldEncryptBody = ['POST', 'PUT', 'PATCH'].includes(method) && req.body != null;

    let url: URL;
    try {
      url = new URL(req.url, window.location.origin);
    } catch {
      // Don't break requests if URL parsing fails
      return next.handle(req);
    }

    if (!url.searchParams.has('payload_encrypt')) {
      url.searchParams.set('payload_encrypt', 'true');
    }
    const reqWithParam = req.clone({ url: url.toString() });

    // Only encrypt JSON-like bodies
    const isJsonBody =
      shouldEncryptBody &&
      !(req.body instanceof FormData) &&
      !(req.body instanceof Blob) &&
      !(req.body instanceof ArrayBuffer) &&
      !(req.body instanceof Uint8Array);

    if (!isJsonBody) {
      return next.handle(reqWithParam);
    }

    const aad = { method, path: url.pathname };

    return from(this.enc.encryptJson(req.body, aad)).pipe(
      switchMap(envelope => {
        const encryptedReq = reqWithParam.clone({
          body: envelope,
          setHeaders: {
            'Content-Type': 'application/json',
            'X-Payload-Encrypted': 'true'
          }
        });
        return next.handle(encryptedReq);
      }),
      catchError(err => {
        console.error('[PayloadEncryptionInterceptor] encryptJson failed:', err);
        return throwError(() => err);
      })
    );
  }
}
